import React, { useCallback, useState, FormEvent } from 'react';
import Form from 'react-bootstrap/Form';
import { Feedback } from '../../Interface/ValidatorFeedback';
import { Type } from '../../Enum/Feedback/Type';

interface Props {
    error: boolean;
    submitFeedbackForm: (feedback: Feedback) => void;
    submitted: boolean;
}

interface State {
    feedback: Feedback;
}

const FeedbackForm: React.FC<Props> = ({ error, submitFeedbackForm, submitted }: Props) => {
    const [{ feedback }, setState] = useState<State>({ feedback: {} as Feedback });

    const submitForm = useCallback(
        (event: FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            submitFeedbackForm(feedback);
        },
        [feedback, submitFeedbackForm],
    );

    return (
        <>
            {!submitted && (
                <Form id="feedback-form" onSubmit={submitForm}>
                    <Form.Group className="mb-0">
                        <Form.Label>
                            <strong>Uw gegevens</strong>
                        </Form.Label>
                    </Form.Group>
                    <Form.Group controlId="name">
                        <Form.Label>
                            Naam: <span className="required">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Naam"
                            onChange={(e: any) => setState({ feedback: { ...feedback, name: e.target.value } })}
                        />
                    </Form.Group>
                    <Form.Group controlId="phone">
                        <Form.Label>Telefoon:</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Telefoon"
                            onChange={(e: any) => setState({ feedback: { ...feedback, phone: e.target.value } })}
                        />
                    </Form.Group>
                    <Form.Group controlId="email">
                        <Form.Label>Email:</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Email"
                            onChange={(e: any) => setState({ feedback: { ...feedback, email: e.target.value } })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-0">
                        <Form.Label>
                            <strong>Uw melding</strong>
                        </Form.Label>
                    </Form.Group>
                    <Form.Group controlId="type">
                        <Form.Label>
                            Ik heb een: <span className="required">*</span>
                        </Form.Label>
                        <Form.Control
                            as="select"
                            required
                            onChange={(e: any) => setState({ feedback: { ...feedback, type: e.target.value } })}
                        >
                            <option value="" selected disabled>
                                Maak een keuze
                            </option>
                            <option value={Type.SUGGESTION}>Suggestie</option>
                            <option value={Type.PROBLEM}>Probleem</option>
                            <option value={Type.QUESTION}>Vraag</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="message">
                        <Form.Label>
                            Omschrijving: <span className="required">*</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            required
                            placeholder="Uw melding"
                            onChange={(e: any) => setState({ feedback: { ...feedback, message: e.target.value } })}
                        />
                    </Form.Group>
                    <p>
                        Velden met een <span className="required">*</span> zijn verplicht.
                    </p>
                </Form>
            )}
            {submitted && (
                <p>
                    Uw bericht is succesvol verzonden. Bedankt voor het melden van verbeterpunten, wij nemen uw feedback
                    in behandeling.
                </p>
            )}
            {error && (
                <p>
                    Er is een fout opgetreden bij het versturen van de feedback. Mail naar{' '}
                    <a href="mailto:info@findata.nl?subject=Fout bij versturen van het feedback formulier.">FinData</a>{' '}
                    om dit melden.
                </p>
            )}
        </>
    );
};

export default FeedbackForm;
